/* eslint-disable */
import Vue from 'vue'

// css
import '../../node_modules/uikit/dist/css/uikit.min.css'
import '../sass/index.scss'

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

import VueScrollactive from 'vue-scrollactive';


UIkit.use(Icons);

Vue.config.productionTip = false
Vue.use(VueScrollactive);

import mixin from '../utils/mixin'

import AppToCheckout from '@/components/AppToCheckout.vue'
import AppFormatNumber from '@/components/AppFormatNumber'
import AppCountDown from '@/components/AppCountDown'

new Vue({
  el: '#app',
  mixins: [mixin],
  components: { AppToCheckout, AppFormatNumber, AppCountDown },
  data() {
    return {
      showModal: false,
      currentUrl: '',
    }
  },
  methods: {
    triggerLogin(path) {
      this.toLogin(path)
    },
    copyLink() {
      this.showModal = true
      this.currentUrl = window.location.href
      
      const el = document.createElement('textarea');
      el.value = this.currentUrl;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

    }
  },
  created() {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 0)
  }
})
